module.exports = __webpack_public_path__ + "pc/img/puzzle_02.edbc5542.png";